import { $vars } from '../../../config/vars';
import { the_language } from '../../y/i18n';
import { yLoadAsyncScript } from '../../y/util';
import { UIView } from '../view';

export namespace $stripe {
    const script_promise = yLoadAsyncScript('https://js.stripe.com/v3/');
    let live_promise: Promise<any>
    let test_promise: Promise<any>

    export function init(test: boolean) {
        if(!$vars.stripe) return Promise.reject();

        if(test) {
            if(!test_promise)
                test_promise = script_promise.then(() => Stripe($vars.stripe.test_key));
            return test_promise;
        } else {
            if(!live_promise)
                live_promise = script_promise.then(() => Stripe($vars.stripe.live_key));
            return live_promise;
        }
    }

    export class Form extends UIView {
        _element: Promise<[stripe.Stripe, stripe.elements.Elements]>;
        _redirect_url: string;
        _is_setup: boolean;

        constructor(test_mode: boolean, client_secret: string, is_setup: boolean, redirect_url: string) {
            super('div', 'ui-payment-form');
            this._redirect_url = redirect_url;
            this._is_setup = is_setup;

            this._element = init(test_mode).then(s => {
                const elements = s.elements({ appearance: { theme: 'stripe' }, clientSecret: client_secret, loader: 'always', locale: the_language });
                // TODO: we can remove this as long as we provide it manually
                // const element = elements.create('payment', { fields: { billingDetails: { address: 'never' }} });
                const element = elements.create('payment');
                element.mount(this.root);
                return [s, elements];
            });
        }

        submit() {
            if(this._is_setup) {
                return this._element.then(e => (e[0] as any).confirmSetup({ elements: e[1], redirect: 'if_required', confirmParams: { return_url: this._redirect_url } })).then(result => {
                    if(result.error)
                        throw result.error;
                    return result;
                });
            } else {
                return this._element.then(e => (e[0] as any).confirmPayment({ elements: e[1], redirect: 'if_required', confirmParams: { return_url: this._redirect_url } })).then(result => {
                    if(result.error)
                        throw result.error;
                    return result;
                });
            }
        }
    }
}
